// Configuración de imágenes generadas para Atomic Corporation
// Todas las imágenes están optimizadas y subidas a Cloudinary

export interface GeneratedImage {
  id: string;
  cloudinaryUrl: string;
  publicId: string;
  alt: string;
  category: 'industries' | 'services' | 'products' | 'about';
}

// INDUSTRIAS (5 completadas)
export const industryImages: GeneratedImage[] = [
  {
    id: 'industry-paper',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762908888/df3smahs9r4ibyuqedru.webp',
    publicId: 'df3smahs9r4ibyuqedru.webp',
    alt: 'Industria Papelera - Equipos de procesamiento de papel y celulosa',
    category: 'industries'
  },
  {
    id: 'industry-fishing',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762908988/usji8fynuxt68qxoejxo.webp',
    publicId: 'usji8fynuxt68qxoejxo.webp',
    alt: 'Industria Pesquera - Sistemas de refrigeración y procesamiento',
    category: 'industries'
  },
  {
    id: 'industry-food',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762909167/dboy6zs8zdkkxtpctulh.webp',
    publicId: 'dboy6zs8zdkkxtpctulh.webp',
    alt: 'Industria Alimentaria - Equipos de procesamiento de alimentos',
    category: 'industries'
  },
  {
    id: 'industry-agri',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762909268/dcrdevvt2g5hqbcmwodf.webp',
    publicId: 'dcrdevvt2g5hqbcmwodf.webp',
    alt: 'Agroindustria - Equipos de procesamiento agrícola',
    category: 'industries'
  },
  {
    id: 'industry-manufacturing',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762909347/y0gisc7lujrymh0mzmb9.webp',
    publicId: 'y0gisc7lujrymh0mzmb9.webp',
    alt: 'Industria Manufacturer - Líneas de producción automatizadas',
    category: 'industries'
  }
];

// SERVICIOS (6 completados)
export const serviceImages: GeneratedImage[] = [
  {
    id: 'service-maintenance',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762920153/o4jestbbtiopfwfozpfa.webp',
    publicId: 'o4jestbbtiopfwfozpfa.webp',
    alt: 'Mantenimiento Industrial - Servicio técnico especializado',
    category: 'services'
  },
  {
    id: 'service-installation',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762964655/cxrgma0gyzmd6qgu8xv1.webp',
    publicId: 'cxrgma0gyzmd6qgu8xv1',
    alt: 'Instalación y Montaje - Técnicos especializados instalando maquinaria industrial',
    category: 'services'
  },
  {
    id: 'service-consulting',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762920975/rftnxwtysuw6nxfcq9dz.webp',
    publicId: 'rftnxwtysuw6nxfcq9dz.webp',
    alt: 'Consultoría Técnica - Asesoramiento especializado',
    category: 'services'
  },
  {
    id: 'service-parts',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762920975/iwzoe1m2tqdoacgzursa.webp',
    publicId: 'iwzoe1m2tqdoacgzursa.webp',
    alt: 'Repuestos y Accesorios - Suministro de componentes',
    category: 'services'
  },
  {
    id: 'service-inspection',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762920975/vu7xzqfi6cyi0fwpppwk.webp',
    publicId: 'vu7xzqfi6cyi0fwpppwk.webp',
    alt: 'Inspección y Certificación - Control de calidad',
    category: 'services'
  },
  {
    id: 'service-training',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762921078/a6ekgcbf0q5hjwxqdttx.webp',
    publicId: 'a6ekgcbf0q5hjwxqdttx.webp',
    alt: 'Capacitación Técnica - Educación industrial',
    category: 'services'
  }
];

// PRODUCTOS (6 completados)
export const productImages: GeneratedImage[] = [
  {
    id: 'product-spares',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762921613/dwdv07xyxbw8wntw7cnb.webp',
    publicId: 'dwdv07xyxbw8wntw7cnb.webp',
    alt: 'Repuestos Industriales - Componentes mecánicos',
    category: 'products'
  },
  {
    id: 'product-machinery',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762921673/kiekb35bxwdrk390zcdk.webp',
    publicId: 'kiekb35bxwdrk390zcdk.webp',
    alt: 'Maquinaria Industrial - Equipos de producción',
    category: 'products'
  },
  {
    id: 'product-tools',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762921732/uvkhx3nqzi0pj8jqvqiz.webp',
    publicId: 'uvkhx3nqzi0pj8jqvqiz.webp',
    alt: 'Herramientas Industriales - Equipos de mantenimiento',
    category: 'products'
  },
  {
    id: 'product-safety',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762921463/poglcqozvdk2cbsluhaw.webp',
    publicId: 'poglcqozvdk2cbsluhaw.webp',
    alt: 'Seguridad Industrial - Equipos de protección',
    category: 'products'
  },
  {
    id: 'product-automation',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762921523/pzccm1acgpz0hwi4gla4.webp',
    publicId: 'pzccm1acgpz0hwi4gla4.webp',
    alt: 'Automatización Industrial - Sistemas de control',
    category: 'products'
  },
  {
    id: 'product-catalog',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762921871/wiynooovftuf48w3uxa3.webp',
    publicId: 'wiynooovftuf48w3uxa3.webp',
    alt: 'Catálogo Industrial - Muestra de productos',
    category: 'products'
  }
];

// ABOUT/EQUIPO (10 completadas)
export const aboutImages: GeneratedImage[] = [
  {
    id: 'about-leader',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762922247/dogxjpwcov1oywg9udgs.webp',
    publicId: 'dogxjpwcov1oywg9udgs.webp',
    alt: 'Líder Empresarial - CEO y Fundador',
    category: 'about'
  },
  {
    id: 'about-engineer',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762922312/ufgylbhmzbapmldl0qbq.webp',
    publicId: 'ufgylbhmzbapmldl0qbq.webp',
    alt: 'Director Técnico - Ingeniero Especializado',
    category: 'about'
  },
  {
    id: 'about-specialist',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762922403/w90i9z0w61o7adbwt7im.webp',
    publicId: 'w90i9z0w61o7adbwt7im.webp',
    alt: 'Especialista Profesional - Operaciones',
    category: 'about'
  },
  {
    id: 'about-maria-garcia',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762966445/zeyleuycsrx8s9ufzlvb.webp',
    publicId: 'zeyleuycsrx8s9ufzlvb.webp',
    alt: 'María García - Directora de Operaciones',
    category: 'about'
  },
  {
    id: 'about-sales-advisor',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762922966/x3dat2yj1prmcxwrkjgw.webp',
    publicId: 'x3dat2yj1prmcxwrkjgw.webp',
    alt: 'Asesora de Ventas - Especialista Comercial',
    category: 'about'
  },
  {
    id: 'about-quality-manager',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762923028/twds7jwayexegpag6nhr.webp',
    publicId: 'twds7jwayexegpag6nhr.webp',
    alt: 'Jefe de Calidad - Gestión de Calidad',
    category: 'about'
  },
  {
    id: 'about-project-manager',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762923090/n89ku9yly5nqmtqrh4s5.webp',
    publicId: 'n89ku9yly5nqmtqrh4s5.webp',
    alt: 'Jefe de Proyectos - Gestión de Proyectos',
    category: 'about'
  },
  {
    id: 'testimonial-carlos-mendoza',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762966779/ph7t3vcl9y7wyl5bdlc0.webp',
    publicId: 'ph7t3vcl9y7wyl5bdlc0.webp',
    alt: 'Carlos Mendoza - Papelera del Pacífico',
    category: 'about'
  },
  {
    id: 'testimonial-ana-garcia',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762966831/y3mpx5yurb5yeqzx9tuc.webp',
    publicId: 'y3mpx5yurb5yeqzx9tuc.webp',
    alt: 'Ana García - Procesadora Marina S.A.',
    category: 'about'
  },
  {
    id: 'testimonial-luis-rodriguez',
    cloudinaryUrl: 'https://res.cloudinary.com/dxdwwmdbw/image/upload/v1762966902/vsqjp6l96comajgvy9nn.webp',
    publicId: 'vsqjp6l96comajgvy9nn.webp',
    alt: 'Luis Rodríguez - Agroindustrias del Norte',
    category: 'about'
  }
];

// FUNCIONES DE UTILIDAD
export const getImageUrl = (imageId: string): string | null => {
  const allImages = [...industryImages, ...serviceImages, ...productImages, ...aboutImages];
  const image = allImages.find(img => img.id === imageId);
  return image ? image.cloudinaryUrl : null;
};

export const getAllImages = (): GeneratedImage[] => {
  return [...industryImages, ...serviceImages, ...productImages, ...aboutImages];
};

// VERSIONES OPTIMIZADAS PARA WEB
export const getOptimizedUrl = (imageId: string, width: number = 600, height: number = 400): string => {
  // Si es una URL completa de Cloudinary, la devolvemos tal como está
  if (imageId.startsWith('https://res.cloudinary.com')) {
    return imageId;
  }
  
  // Si es un ID de imagen, buscamos la URL completa
  const fullUrl = getImageById(imageId);
  if (fullUrl) {
    return fullUrl;
  }
  
  // Si no se encuentra, intentamos con las URLs directas del array
  const allImages = [...industryImages, ...serviceImages, ...productImages, ...aboutImages];
  const foundImage = allImages.find(img => img.id === imageId);
  if (foundImage) {
    return foundImage.cloudinaryUrl;
  }
  
  // Último recurso: construir URL básica
  return `https://res.cloudinary.com/dxdwwmdbw/image/upload/v1/${imageId}`;
};

export const getImageById = (imageId: string): string | null => {
  const allImages = [...industryImages, ...serviceImages, ...productImages, ...aboutImages];
  const image = allImages.find(img => img.id === imageId);
  return image ? image.cloudinaryUrl : null;
};

export const getThumbnailUrl = (publicId: string): string => {
  return `https://res.cloudinary.com/dxdwwmdbw/image/upload/v1/${publicId}`;
};

export const PRODUCT_IMAGE_MAP = {
  spares: 'product-spares',
  machinery: 'product-machinery',
  tools: 'product-tools',
  safety: 'product-safety',
  automation: 'product-automation',
  catalog: 'product-catalog'
};

export const INDUSTRY_IMAGE_MAP = {
  paper: 'industry-paper',
  fishing: 'industry-fishing',
  food: 'industry-food',
  agri: 'industry-agri',
  manufacturing: 'industry-manufacturing'
};

export const SERVICE_IMAGE_MAP = {
  maintenance: 'service-maintenance',
  installation: 'service-installation',
  consulting: 'service-consulting',
  parts: 'service-parts',
  inspection: 'service-inspection',
  training: 'service-training'
};

export const ABOUT_IMAGE_MAP = {
  leader: 'about-leader',
  engineer: 'about-engineer',
  specialist: 'about-specialist',
  mariaGarcia: 'about-maria-garcia',
  salesAdvisor: 'about-sales-advisor',
  qualityManager: 'about-quality-manager',
  projectManager: 'about-project-manager',
  carlosMendoza: 'testimonial-carlos-mendoza',
  anaGarcia: 'testimonial-ana-garcia',
  luisRodriguez: 'testimonial-luis-rodriguez'
};

// ESTADÍSTICAS DE IMÁGENES GENERADAS
export const getImageStats = () => ({
  industries: industryImages.length,
  services: serviceImages.length,
  products: productImages.length,
  about: aboutImages.length,
  total: industryImages.length + serviceImages.length + productImages.length + aboutImages.length,
  progress: {
    industries: "100% (5/5)",
    services: "100% (6/6)",
    products: "100% (6/6)",
    about: "100% (10/10)"
  }
});